import { Box, Pagination, Skeleton, Stack, Typography } from "@mui/material"

function TablePagination({ cb = null, limit = 10, length, loading, pagination = {} }) {

  const pageSize = Number(pagination?.limit || limit) || 10
  const totalEntries = pagination?.totalCount || pagination?.totalRecords || 0

  return (
    <>
      <Box
        sx={{
          p: 2,
          gap: "12px",
          display: "flex",
          justifyContent: "space-between",
          borderTop: "1px solid #D7D7D7",
        }}
      >
        {loading ?
          <Skeleton
            variant="text"
            sx={{
              width: "100%",
              maxWidth: 300,
              fontSize: "20px",
            }}
          /> :
          <Typography
            sx={{
              fontSize: "14px",
              fontWeight: "500",
              color: "other.color1",
            }}
          >{`Showing ${pagination?.currentPage ? ((pagination?.currentPage - 1) * pageSize + 1) : 0} to ${((pagination?.currentPage - 1) * pageSize + length) || 0} of ${totalEntries} entries`}
          </Typography>
        }

        {loading ?
          <Stack direction="row" spacing={1}>
            {new Array(6).fill().map((_, i) => (
              <Skeleton
                key={i}
                variant="circular"
                sx={{ width: 25, height: 25 }}
              />
            ))
            }
          </Stack> :
          <Pagination
            as="div"
            shape="circular"
            color="primary"
            boundaryCount={3}
            count={pagination?.totalPages || 1}
            page={pagination?.currentPage || 1}
            onChange={(_, n) => {
              if (pagination?.currentPage === n) return
              if (cb) cb({ currentPage: n })
            }}
            sx={{
              ".MuiPagination-ul": { justifyContent: "end" },
              ".MuiPagination-ul button": {
                width: "25px",
                height: "25px",
                lineHeight: "1",
                minWidth: "auto",
                fontFamily: "Poppins",
              }
            }}
          />
        }
      </Box>
    </>
  )
}

export default TablePagination